var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip-icon',_vm._g(_vm._b({attrs:{"tooltip":_vm.tooltip,"color":_vm.color}},'tooltip-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }